import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { RETIREMENT_STATE_PENSION_AGE } from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementContext } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";
import { formatPercent } from "web_myplann/Shared/Utils/numberFormatters";

const R = Resources.Inspiration.Retirement;

export const useRetirementStateNote = (context: RetirementContext) => {
	const { t } = useResource();

	const income = formatInspirationMoney(context.desiredIncome);
	const coverage =
		context.statePercent >= 100
			? t(R.stateCoversAll, { income })
			: t(R.stateCoversShare, {
					income,
					percent: formatPercent(context.statePercent, 0),
				});

	return {
		note: context.statePensionEdited
			? coverage
			: `${t(R.stateAverageNote)} ${coverage}`,
		fromAgeNote:
			context.bridgeYears > 0
				? t(R.stateFromAge, { age: RETIREMENT_STATE_PENSION_AGE })
				: undefined,
		actionLabel: t(
			context.statePensionEdited ? R.stateEditOwn : R.stateEnterOwn,
		),
	};
};
